import React from "react";
import Pulse from "react-reveal/Pulse";

const Banner = () => {
	return (
		<div className="banner bg-yellow text-dark">
			<Pulse>
			<div className="container-fluid px-0 z-10">
				<img className="object-fit-cover w-100" src="/assets/banner.png" alt="Banner" />
				{/* <div className="container">
					<div className="row flex-column flex-md-row justify-content-md-between align-items-center">
						<div className="col-md-6 order-1 pt-4 pb-5 pb-md-0 px-sm-0">
							<h1 className="font-weight-bold">Enjoy Entertainment beyond reality</h1>
							<p>Watch your favourite artists from anywhere around the world. An experience like never before</p>
							<div className="grid"></div>
						</div>
						<div className="col-md-6 order-md-1 center pb-md-0">
							<img
								src="https://res.cloudinary.com/djwa4cx9u/image/upload/v1624086817/fobs/Google-VR-Headset-Mockup-Free-PSD_1_w0xyxt.png"
								alt="Google VR"
                                loading="lazy"
							/>
						</div>
					</div>
				</div> */}
			</div>
			</Pulse>
		</div>
	);
};

export default Banner;
